var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonyBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 101,
    viewBox: "0 0 83 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3159 19.1836C43.1452 19.2598 45.0507 19.1836 46.88 19.1836C47.1848 19.1836 47.5659 19.1836 47.947 19.2598C47.947 19.7933 47.947 20.1744 47.947 20.5555C47.947 27.4915 47.947 34.4276 47.947 41.3636C47.947 42.8118 48.2519 43.1166 49.6239 43.1166C52.5202 43.1166 55.4166 43.1166 58.313 43.1166C60.3709 43.1166 60.5233 42.9642 60.5233 40.9825C60.5233 34.1227 60.5233 27.3391 60.5233 20.4793C60.5233 20.0982 60.5233 19.7171 60.5233 19.2598C62.6575 19.2598 64.6392 19.2598 66.6209 19.2598C67.3069 19.2598 68.0691 19.4122 68.5264 18.5738C68.9075 17.7354 68.374 17.2018 67.9167 16.6683C63.8008 11.6378 59.6849 6.60727 55.569 1.50053C55.3404 1.19565 54.9593 0.890769 54.6544 0.662109C54.4257 0.662109 54.1208 0.662109 53.8922 0.662109C53.6635 0.890769 53.3587 1.04321 53.2062 1.34809C48.9379 6.60727 44.6696 11.8664 40.4013 17.1256C40.0964 17.5067 39.9439 18.1927 40.1726 18.5738C40.1726 18.8787 40.8586 19.1836 41.3159 19.1836Z",
    fill: "url(#paint0_linear_1374_2980)",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2814 33.207C13.1107 33.2832 14.94 33.207 16.7693 33.207C17.0741 33.207 17.4552 33.207 17.8363 33.2832C17.8363 33.7405 17.8363 34.1979 17.8363 34.579C17.8363 41.515 17.8363 48.3748 17.8363 55.3108C17.8363 56.9114 18.1412 57.1401 19.7418 57.1401C22.6382 57.1401 25.6108 57.1401 28.5071 57.1401C30.1077 57.1401 30.4126 56.8352 30.4126 55.3108C30.4126 48.3748 30.4126 41.515 30.4126 34.579C30.4126 34.1979 30.4126 33.8168 30.4126 33.2832C30.87 33.2832 31.2511 33.2832 31.5559 33.2832C33.309 33.2832 35.1383 33.3594 36.8913 33.2832C37.3486 33.2832 38.0346 32.9783 38.2633 32.5972C38.4157 32.2161 38.2633 31.4539 37.9584 31.1491C33.6901 25.8899 29.4218 20.6307 25.1535 15.3715C24.3913 14.4569 23.7053 14.4569 22.9431 15.3715C18.6748 20.6307 14.4064 25.8137 10.1381 31.1491C9.83325 31.5302 9.6808 32.2924 9.83324 32.5972C10.1381 32.9021 10.8241 33.207 11.2814 33.207Z",
    fill: "url(#paint1_linear_1374_2980)",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.672 90.7524C35.2147 90.2189 34.6812 89.9902 33.9952 89.9902C24.6964 89.9902 15.3975 89.9902 6.09869 89.9902C5.56515 89.9902 5.03161 89.9902 4.57429 90.0665C1.75415 90.5238 -0.227563 93.2677 0.229757 96.0878C0.687077 98.908 2.82124 100.661 5.79382 100.661C17.303 100.661 28.736 100.661 40.2452 100.661C41.3123 100.661 42.3032 100.661 43.3703 100.661C45.1995 100.585 46.6477 99.7464 47.7148 98.1458C47.4099 98.0696 47.2575 97.9933 47.105 97.9171C42.6081 96.5452 38.7971 94.1823 35.672 90.7524Z",
    fill: "url(#paint2_linear_1374_2980)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63986 87.6298C14.4814 87.6298 23.3229 87.6298 32.1644 87.6298C32.4693 87.6298 32.6979 87.6298 33.1553 87.5536C31.0211 84.2761 29.7254 80.77 29.268 77.0352C29.0394 76.959 28.9632 76.959 28.8869 76.959C21.0363 76.959 13.1094 76.959 5.25876 76.959C5.10632 76.959 4.95389 76.959 4.80145 76.959C1.90509 77.2639 -0.305292 80.1602 0.228248 83.0566C0.685568 85.8767 2.81972 87.6298 5.63986 87.6298Z",
    fill: "url(#paint3_linear_1374_2980)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64159 74.5946C13.1874 74.5946 20.8094 74.5946 28.3551 74.5946C28.5076 74.5946 28.66 74.5946 28.9649 74.5184C28.8887 70.8598 29.5747 67.3537 30.9466 63.9238C30.4131 63.9238 30.1082 63.9238 29.7271 63.9238C21.8765 63.9238 14.0258 63.9238 6.17514 63.9238C5.71782 63.9238 5.33671 63.9238 4.87939 63.9238C1.83059 64.0763 -0.455996 67.0488 0.0775441 70.0976C0.687304 72.8416 2.74523 74.5184 5.64159 74.5946Z",
    fill: "url(#paint4_linear_1374_2980)",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8441 47.9196C46.4202 47.691 35.2159 58.2856 34.8348 70.2521C34.3775 83.8193 44.8196 94.8712 58.1581 95.176C71.1155 95.4047 81.7101 85.0388 82.0149 71.8527C82.3198 58.8191 72.0301 48.1483 58.8441 47.9196ZM54.4995 67.0509C55.1093 68.7277 56.3288 69.7186 58.1581 69.871C59.7587 69.9472 61.3593 70.2521 62.7313 71.1667C65.3228 72.996 66.2374 75.5875 65.8563 78.7125C65.4752 81.6089 63.8746 83.5906 61.1307 84.5815C60.3685 84.8863 60.0636 85.1912 60.1398 85.9534C60.216 86.5632 60.216 87.1729 60.0636 87.7065C59.9112 88.6211 59.3776 89.1547 58.3868 89.1547C57.3959 89.1547 56.7099 88.6211 56.7861 87.7065C57.091 85.5723 56.0239 84.6577 54.2709 83.743C52.0605 82.5997 50.9934 80.3894 50.841 77.8741C50.7648 76.7308 51.3745 75.9686 52.3654 75.8162C53.3562 75.7399 54.0422 76.3497 54.1947 77.493C54.5758 80.0083 55.9477 81.4564 58.1581 81.6089C60.4447 81.7613 62.274 80.2369 62.5789 77.8741C62.8837 75.8162 61.4356 73.7582 59.3014 73.3009C58.5392 73.1485 57.777 73.1485 57.0148 72.996C53.5087 72.31 51.0696 69.5661 50.841 65.9076C50.6123 62.6301 52.6702 59.5813 55.9477 58.3618C56.1764 58.2856 56.4813 58.1331 56.7861 58.0569C56.7861 57.2185 56.7861 56.3801 56.7861 55.5416C56.8624 54.5508 57.4721 53.8648 58.3868 53.7886C59.3014 53.7886 60.216 54.4746 60.0636 55.3892C59.8349 57.3709 60.6733 58.2856 62.4264 59.124C64.7892 60.2673 65.7801 62.5539 66.0088 65.1454C66.085 66.2887 65.399 67.0509 64.4081 67.1271C63.4935 67.2033 62.7313 66.5173 62.6551 65.4502C62.5026 63.5447 61.588 62.0966 59.7587 61.4868C58.1581 60.9533 56.7099 61.2581 55.4904 62.4014C54.3471 63.8496 53.966 65.374 54.4995 67.0509Z",
    fill: "url(#paint5_linear_1374_2980)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1374_2980",
    x1: 40.0633,
    y1: 21.8863,
    x2: 68.6596,
    y2: 21.8863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1374_2980",
    x1: 9.77425,
    y1: 35.9097,
    x2: 38.3262,
    y2: 35.9097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1374_2980",
    x1: 0.165408,
    y1: 95.3249,
    x2: 47.72,
    y2: 95.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1374_2980",
    x1: 0.149372,
    y1: 82.2936,
    x2: 33.1589,
    y2: 82.2936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1374_2980",
    x1: 0.000875782,
    y1: 69.2584,
    x2: 30.9501,
    y2: 69.2584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1374_2980",
    x1: 34.8216,
    y1: 71.5444,
    x2: 82.0268,
    y2: 71.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonyBadge);
export default __webpack_public_path__ + "static/media/MonyBadge.41fcb502dd54686eaa90a7947e8313f4.svg";
export { ForwardRef as ReactComponent };